import { countBadgeText } from '@/utils/countBadge'

/**
 * How far I've read, from the Messages that have come on screen: the Message id to mark
 * the Chat read up to, or null when `shownMessageId` is no further than what's already
 * marked. The server never moves the position backwards, so only a newer Message is
 * worth telling it about. Ported from iOS `ChatReadPosition`.
 */
export const advanceReadPosition = (lastReadMessageId: number | null, shownMessageId: number): number | null =>
	shownMessageId > (lastReadMessageId ?? -Infinity) ? shownMessageId : null

/** What the Chat button's badge says; null hides it. Ported from iOS `ChatUnreadBadge`. */
export const unreadBadgeText = (unreadCount: number): string | null => countBadgeText(unreadCount)
